import { Button } from "@heroui/react";
import { Checkmark, Edit } from "assets/icons";

interface EditToggleProps {
  editMode: boolean;
  onEditClick: () => void;
  onSaveClick: () => void;
  classNames?: string;
}

export const EditToggle: React.FC<EditToggleProps> = ({
  editMode,
  onEditClick,
  onSaveClick,
  classNames = "",
}) => {
  if (editMode) {
    return (
      <Button
        onClick={onSaveClick}
        className={`${classNames} h-fit min-w-fit gap-1 rounded-none bg-transparent p-0 text-sm font-medium text-moss-primary hover:bg-transparent`}
      >
        <Checkmark className="h-[18px] w-[18px]" />
        Bewaar
      </Button>
    );
  } else {
    return (
      <Button
        onClick={onEditClick}
        className={`${classNames} h-fit min-w-fit gap-1 rounded-none bg-transparent p-0 text-sm font-medium text-moss-primary hover:bg-transparent`}
      >
        <Edit className="h-[18px] w-[18px]" />
        Wijzig gegevens
      </Button>
    );
  }
};
